import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createInquiryRelatedDivision } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

export function useCreateInquiryRelatedDivision(inquiryId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (divisionId: number) => {
      return createInquiryRelatedDivision(inquiryId, { divisionId })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiries.all() })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.relatedDivisions(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.actionLogs(inquiryId) })
      queryClient.invalidateQueries({ queryKey: queryKeys.inquiry.assignMembers.all() })
    },
  })
}
